<loading [visible]="saving()"></loading>

@if(!loading()){
<form [formGroup]="saveForm" (submit)="false" class="flex flex-col gap-2 min-h-[calc(100dvh-4rem)] max-w-7xl mx-auto">

  <section class="flex justify-between items-center mb-1">
    <h1 class="text-2xl font-bold text-gray-800">
      {{ viewOnly ? 'Recuento de inventario' : 'Nuevo recuento de inventario' }}
    </h1>
    <a routerLink="/inventory-history" class="text-sm font-bold text-slate-500 hover:text-slate-700">
      &larr; Volver al historial
    </a>
  </section>

  <section class="bg-white border border-slate-200 rounded-2xl shadow-sm p-4">
    <div class="flex flex-row items-end gap-3">
      <div class="flex-1">
        <custom-input label="Fecha" type="date" [formControlItem]="saveForm.controls['date']"></custom-input>
      </div>

      <div class="flex-1">
        <custom-select label="Oficina" [formControlItem]="saveForm.controls['office_id']" [options]="dropdowns.offices"
          bindValue="id" bindLabel="name" [isMultiple]="false" placeholder="Selecciona una oficina (opcional)">
        </custom-select>
      </div>
    </div>
  </section>

  <section class="flex-1 flex flex-col bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">

    @if(!viewOnly) {
    <div class="p-3 border-b border-slate-100 bg-white flex flex-row items-center gap-3">
      <div class="relative flex-1">
        <span class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">🔍</span>
        <input type="text" [formControl]="search" placeholder="BUSCAR PRODUCTO POR NOMBRE O REFERENCIA..."
          class="w-full pl-12 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold text-slate-700 focus:bg-white focus:ring-4 focus:ring-blue-500/10 outline-none transition-all uppercase tracking-wider">

        @if(search.value && filteredProducts().length > 0) {
        <div class="absolute z-50 w-full mt-2 bg-white border border-slate-200 rounded-2xl shadow-xl max-h-60 overflow-y-auto p-2">
          @for(prod of filteredProducts(); track prod.id) {
          <button type="button" (click)="selectProductFromSearch(prod)"
            class="w-full flex items-center justify-between p-3 hover:bg-blue-50 rounded-xl text-left transition-colors group">
            <div class="flex flex-col">
              <span class="text-sm font-bold text-slate-700 uppercase">{{ prod.name }}</span>
              <span class="text-[10px] font-bold text-slate-400">REF: {{prod.code}}</span>
            </div>
          </button>
          }
        </div>
        }
      </div>

      <button type="button" (click)="loadAllProducts()"
        class="py-3 px-4 bg-slate-800 text-white hover:bg-slate-700 rounded-2xl font-bold text-xs tracking-widest transition-all uppercase whitespace-nowrap">
        Cargar todos los productos
      </button>
    </div>
    }

    <div class="flex-1 overflow-auto">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 bg-slate-50/90 backdrop-blur-sm text-slate-500 z-10 border-b border-slate-100">
          <tr>
            <th class="px-4 py-2.5 text-[10px] font-bold uppercase tracking-widest">Producto</th>
            <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-center w-32">Stock actual</th>
            <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-center w-32">Stock contado</th>
            <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-center w-32">Diferencia</th>
            @if(!viewOnly) {
            <th class="w-10"></th>
            }
          </tr>
        </thead>
        <tbody formArrayName="details" class="divide-y divide-slate-50">
          @for (item of detailControls; track item; let i = $index) {

          <tr [formGroupName]="i">
            <td class="px-4 py-2">
              <span class="text-sm font-bold text-slate-700 uppercase leading-tight">
                {{ item.get('name')?.value }}
              </span>
              <span class="block text-[10px] font-bold text-slate-400">REF: {{ item.get('code')?.value }}</span>
            </td>

            <td class="px-3 py-2 text-center font-mono font-bold text-slate-500 text-sm">
              {{ item.get('prev_stock')?.value }}
            </td>

            <td class="px-3 py-2">
              <input type="text" inputmode="decimal" decimalInput formControlName="new_stock"
                class="w-full py-1.5 bg-slate-50 border border-slate-200 rounded-lg text-center font-bold text-slate-700 text-sm outline-none disabled:bg-transparent disabled:border-none">
            </td>

            <td class="px-3 py-2 text-center font-mono font-black text-sm"
              [class.text-emerald-600]="difference(item) > 0"
              [class.text-red-600]="difference(item) < 0"
              [class.text-slate-400]="difference(item) === 0">
              {{ difference(item) > 0 ? '+' : '' }}{{ difference(item) }}
            </td>

            @if(!viewOnly) {
            <td class="px-3 py-2 text-center">
              <button type="button" (click)="removeRow(i)" tabindex="-1"
                class="text-slate-300 hover:text-red-500 outline-none">✕</button>
            </td>
            }
          </tr>

          }

          @if(detailControls.length === 0) {
          <tr>
            <td colspan="5" class="px-4 py-8 text-center text-sm text-slate-400">
              No hay productos añadidos al recuento.
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </section>

  @if(!viewOnly) {
  <section class="sticky bottom-0 z-20 bg-slate-900 rounded-2xl p-3 text-white shadow-2xl shadow-slate-900/40 border border-white/5 flex justify-end">
    <button (click)="saveEntity()" type="submit" [disabled]="saveForm.invalid || details.length === 0 || saving()"
      class="w-48 py-3 bg-blue-600 text-white hover:bg-blue-500 rounded-xl font-bold text-xs tracking-widest transition-all uppercase shadow-lg shadow-blue-900/20 disabled:opacity-30">
      Guardar recuento
    </button>
  </section>
  }

</form>
}
